import Store from "@/store/index";

import ProfilesList from "@/pages/profile/list/index";
import Profile from "@/pages/profile/form/index";

import { userPermissionsList } from "@/constants/userPermissions";

export default [
    {
        path: "/profiles",
        name: "profiles",
        component: ProfilesList,
        meta: {
            title: "Анкеты",
        },
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                const permissions = [userPermissionsList.profiles.control];

                Store.dispatch("getUserPermissions").then(() => {
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },

    {
        path: "/profiles/create",
        name: "create-profile",
        component: Profile,
        meta: {
            title: "Новая анкета",
        },
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                const permissions = [userPermissionsList.profiles.control];

                Store.dispatch("getUserPermissions").then(() => {
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
    {
        path: "/profiles/:id",
        name: "edit-profile",
        component: Profile,
        meta: {
            title: "Редактировать анкету",
        },
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                const permissions = [userPermissionsList.profiles.control];

                Store.dispatch("getUserPermissions").then(() => {
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
];
